__turbopack_context__.v({
  "className": "big_shoulders_2c9321c2-module__DFYAaG__className",
});
